<template>
  <i
    :class="['material-icons', 'icon-button', `md-${size ? size : '24'}`]"
    @click="toggleTheme()"
    >{{ dark_mode ? "wb_sunny" : "brightness_4" }}</i
  >
</template>

<script>
export default {
  props: {
    size: String,
  },
  data() {
    return {
      dark_mode: this.is_dark_mode(),
    };
  },
  computed: {},
  methods: {
    is_dark_mode() {
      if (localStorage.getItem("theme") === "theme-dark") {
        return true;
      } else {
        window.light();
        return false;
      }
    },
    toggleTheme() {
      if (this.dark_mode) {
        window.light();
        this.dark_mode = false;
      } else {
        window.dark();
        this.dark_mode = true;
      }
    },
  },
};
</script>

<style></style>
